import { motion } from "framer-motion";
import { t } from "i18next";
import Image from "next/image";
import type { FC } from "react";

import Images from "styles/image-library";

interface Strategy {
  name: string;
  icon: string;
  title: string;
  subtitle: string;
  apyValue: string;
  isActive: boolean;
  pros: {
    text: string;
    tooltip: string;
  }[];
}

export interface DelegationBodyProps {
  strategies: Strategy[];
  setIsMarinadeNativeStake: (isActive: boolean) => void;
  closeSettingsPopup: () => void;
}

export const DelegationBody: FC<DelegationBodyProps> = ({
  strategies,
  setIsMarinadeNativeStake,
  closeSettingsPopup,
}) => {
  return (
    <div className="flex flex-col">
      {strategies.map((strategy) => (
        <motion.button
          key={strategy.name}
          whileTap={{ scale: 0.95, animationDuration: "0.2s" }}
          className={`flex w-full flex-col mb-3 rounded-2xl items-center px-2 md:px-4 py-4 text-secondary-text relative ${
            strategy.isActive
              ? "border-primary border-2 bg-fade-green"
              : "bg-secondary-bg"
          }`}
          onClick={() => {
            closeSettingsPopup();
            setIsMarinadeNativeStake(strategy.name === "native");
          }}
        >
          <div className="flex w-full items-center text-secondary-text relative">
            <Image
              src={strategy.icon}
              height={48}
              width={48}
              alt="Strategy icon"
            />
            <div className="flex flex-col text-left ml-3">
              <p className="font-semibold text-primary-text text-xl">
                {strategy.name === "native"
                  ? t("app.staking.selection.mode.native.title")
                  : t("app.staking.selection.mode.liquid.title")}
              </p>
              <p className="text-secondary-text text-sm">{strategy.subtitle}</p>
            </div>
          </div>
          <div className="bg-fade-green gap-2 rounded-xl w-full mt-5 flex py-2 px-3 items-start">
            {strategy.name === "native" ? (
              <Image
                src={Images.icons_check}
                height={10}
                width={14}
                alt="Check icon"
              />
            ) : (
              <Image
                src={Images.icons_stacking}
                height={19}
                width={19}
                alt="Staking icon"
              />
            )}
            <p className="text-left text-sm text-black">
              {t(
                strategy.name === "native"
                  ? "app.staking.selection.mode.native.notice"
                  : "app.staking.selection.mode.liquid.notice"
              )}
            </p>
          </div>
          <div className="absolute right-4 text-right">
            <p className="font-semibold text-sm text-tertiary-text mb-3-px">
              APY
            </p>
            <span className="text-xl font-semibold text-primary">
              {strategy.apyValue}%
            </span>
          </div>
        </motion.button>
      ))}
    </div>
  );
};
